export const TARGET = {
  _blank: "_blank" as const,
  _self: "_self" as const,
  _parent: "_parent" as const,
  _top: "_top" as const,
}
